<template>
  <div>
    <v-btn
      class="mb-1"
      color="primary"
      style="width: 100%"
      :href="getActivityUrl"
      :disabled="getActivityStatus != 'active'"
      max-width="250px"
    >
      <span v-if="getActivityStatus == 'ended'">{{ $t("participant.lobby.ended") }}</span>
      <span v-else>{{ $t("participant.lobby.join") }}</span>
    </v-btn>
    <div
      class="text-caption"
      v-if="
        (getActivityStatus == 'pending' || getActivityStatus == 'active') &&
        activityStartsIn < 1440 &&
        activityStartsIn > 0
      "
    >
      {{ $t("participant.lobby.startsIn") }} {{ activityStartsIn | duration }}
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "ParticipantLobbyTimer",
  props: {
    activity: {},
  },
  data() {
    return {};
  },
  computed: {
    currentDate() {
      return this.$store.state.serverTime;
    },
    getActivityStatus() {
      let mDate = moment(this.activity.date);
      let date = moment(this.currentDate);
      if (date.add(30, "minutes").isBefore(mDate)) {
        return "pending";
      }
      if (mDate.add(this.activity.duration, "minutes").isBefore(this.currentDate)) {
        return "ended";
      }
      return "active";
    },
    activityStartsIn() {
      let startDate = moment(this.activity.date);
      if (this.currentDate.isAfter(startDate)) {
        return "";
      } else {
        return startDate.diff(this.currentDate, "minutes");
      }
    },
    getActivityUrl() {
      return `/online/${this.activity.slug}${location.search}`;
    },
  },
};
</script>

<style></style>
